/* tslint:disable */
/* eslint-disable */
/**
 * Simple API with JWT Auth
 * A minimal OpenAPI spec with JWT authentication and simple models.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { updateIsDeleted, isDeleted, isNew, updateIsNew } from "@/api/util";
import { registerMeta } from "@/api/meta";
import {
  propertyMeta,
  typeMeta,
  typeMetaEnum,
  MetaTypesBase,
  EnumMetaType,
  MetaType,
  MetaTypeBase,
  PropertyMeta,
  AssignOptions,
  AssignOptionsRequired,
  FilterVarsType,
  getAssignOptions,
} from "../common";

// May contain unused imports in some cases
// @ts-ignore
import type {
  UnifiedClassTypeBase,
  UnifiedClassTypeBaseOptional,
  UnifiedClassTypeBaseMetaI,
  UnifiedClassTypeBaseTrackedI,
} from "./unified-class-type-base";
import {
  UnifiedClassTypeBaseTracked,
  UnifiedClassTypeBaseMeta,
} from "./unified-class-type-base";
// May contain unused imports in some cases
// @ts-ignore
import type {
  WithNoSignup,
  WithNoSignupOptional,
  WithNoSignupMetaI,
  WithNoSignupTrackedI,
} from "./with-no-signup";
import { WithNoSignupTracked, WithNoSignupMeta } from "./with-no-signup";
// May contain unused imports in some cases
// @ts-ignore
import type {
  WithSignupMax,
  WithSignupMaxOptional,
  WithSignupMaxMetaI,
  WithSignupMaxTrackedI,
} from "./with-signup-max";
import { WithSignupMaxTracked, WithSignupMaxMeta } from "./with-signup-max";
// May contain unused imports in some cases
// @ts-ignore
import type {
  WithSignupMin,
  WithSignupMinOptional,
  WithSignupMinMetaI,
  WithSignupMinTrackedI,
} from "./with-signup-min";
import { WithSignupMinTracked, WithSignupMinMeta } from "./with-signup-min";

/**
 *
 * @export
 * @interface ApClassTypeBase
 */
export interface ApClassTypeBaseOptional extends UnifiedClassTypeBaseOptional {
  /**
   *
   * @type {string}
   * @memberof ApClassTypeBase
   */
  typeName?: string;
  /**
   *
   * @type {number}
   * @memberof ApClassTypeBase
   */
  displayOrder?: number;
  /**
   *
   * @type {boolean}
   * @memberof ApClassTypeBase
   */
  prereqMustComplete?: boolean;
  /**
   *
   * @type {number}
   * @memberof ApClassTypeBase
   */
  signupMax?: number;
  /**
   *
   * @type {number}
   * @memberof ApClassTypeBase
   */
  signupMin?: number;
  /**
   *
   * @type {boolean}
   * @memberof ApClassTypeBase
   */
  noSignup?: boolean;
  /**
   *
   * @type {string}
   * @memberof ApClassTypeBase
   */
  descLong?: string;
  /**
   *
   * @type {string}
   * @memberof ApClassTypeBase
   */
  descShort?: string;
  /**
   *
   * @type {string}
   * @memberof ApClassTypeBase
   */
  colorCode?: string;
  /**
   *
   * @type {number}
   * @memberof ApClassTypeBase
   */
  priceDefault?: number;
  /**
   *
   * @type {boolean}
   * @memberof ApClassTypeBase
   */
  disallowIfOverkill?: boolean;
  /**
   *
   * @type {string}
   * @memberof ApClassTypeBase
   */
  teachUrl?: string;
}

export interface ApClassTypeBase
  extends
    ApClassTypeBaseOptional,
    UnifiedClassTypeBase,
    WithNoSignup,
    WithSignupMax,
    WithSignupMin {
  /**
   *
   * @type {string}
   * @memberof ApClassTypeBase
   */
  typeName?: string;
  /**
   *
   * @type {number}
   * @memberof ApClassTypeBase
   */
  displayOrder?: number;
  /**
   *
   * @type {boolean}
   * @memberof ApClassTypeBase
   */
  prereqMustComplete?: boolean;
  /**
   *
   * @type {number}
   * @memberof ApClassTypeBase
   */
  signupMax?: number;
  /**
   *
   * @type {number}
   * @memberof ApClassTypeBase
   */
  signupMin?: number;
  /**
   *
   * @type {boolean}
   * @memberof ApClassTypeBase
   */
  noSignup?: boolean;
  /**
   *
   * @type {string}
   * @memberof ApClassTypeBase
   */
  descLong?: string;
  /**
   *
   * @type {string}
   * @memberof ApClassTypeBase
   */
  descShort?: string;
  /**
   *
   * @type {string}
   * @memberof ApClassTypeBase
   */
  colorCode?: string;
  /**
   *
   * @type {number}
   * @memberof ApClassTypeBase
   */
  priceDefault?: number;
  /**
   *
   * @type {boolean}
   * @memberof ApClassTypeBase
   */
  disallowIfOverkill?: boolean;
  /**
   *
   * @type {string}
   * @memberof ApClassTypeBase
   */
  teachUrl?: string;
}

export interface ApClassTypeBaseTrackedI extends UnifiedClassTypeBaseOptional {
  /**
   *
   * @type {string}
   * @memberof ApClassTypeBase
   */
  typeName?: string;
  typeNameIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof ApClassTypeBase
   */
  displayOrder?: number;
  displayOrderIsSet: boolean;
  /**
   *
   * @type {boolean}
   * @memberof ApClassTypeBase
   */
  prereqMustComplete?: boolean;
  prereqMustCompleteIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof ApClassTypeBase
   */
  signupMax?: number;
  signupMaxIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof ApClassTypeBase
   */
  signupMin?: number;
  signupMinIsSet: boolean;
  /**
   *
   * @type {boolean}
   * @memberof ApClassTypeBase
   */
  noSignup?: boolean;
  noSignupIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof ApClassTypeBase
   */
  descLong?: string;
  descLongIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof ApClassTypeBase
   */
  descShort?: string;
  descShortIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof ApClassTypeBase
   */
  colorCode?: string;
  colorCodeIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof ApClassTypeBase
   */
  priceDefault?: number;
  priceDefaultIsSet: boolean;
  /**
   *
   * @type {boolean}
   * @memberof ApClassTypeBase
   */
  disallowIfOverkill?: boolean;
  disallowIfOverkillIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof ApClassTypeBase
   */
  teachUrl?: string;
  teachUrlIsSet: boolean;
}

transformDatesMap.set("ApClassTypeBase", function (model: ApClassTypeBase) {});

export type ApClassTypeBaseMetaI = MetaType<{
  //isDate: false
  //isDatetime: false
  typeName: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  displayOrder: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  prereqMustComplete: PropertyMeta<MetaTypeBase<boolean>>;
  //isDate: false
  //isDatetime: false
  signupMax: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  signupMin: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  noSignup: PropertyMeta<MetaTypeBase<boolean>>;
  //isDate: false
  //isDatetime: false
  descLong: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  descShort: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  colorCode: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  priceDefault: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  disallowIfOverkill: PropertyMeta<MetaTypeBase<boolean>>;
  //isDate: false
  //isDatetime: false
  teachUrl: PropertyMeta<MetaTypeBase<string>>;
}>;

export var ApClassTypeBaseMeta: ApClassTypeBaseMetaI =
  {} as ApClassTypeBaseMetaI;
ApClassTypeBaseMeta = typeMeta("ApClassTypeBase", {
  typeName: propertyMeta("typeName", false, false, false, MetaTypesBase.string),
  displayOrder: propertyMeta(
    "displayOrder",
    false,
    false,
    false,
    MetaTypesBase.number,
  ),
  prereqMustComplete: propertyMeta(
    "prereqMustComplete",
    false,
    false,
    false,
    MetaTypesBase.boolean,
  ),
  signupMax: propertyMeta(
    "signupMax",
    false,
    false,
    false,
    MetaTypesBase.number,
  ),
  signupMin: propertyMeta(
    "signupMin",
    false,
    false,
    false,
    MetaTypesBase.number,
  ),
  noSignup: propertyMeta(
    "noSignup",
    false,
    false,
    false,
    MetaTypesBase.boolean,
  ),
  descLong: propertyMeta("descLong", false, false, false, MetaTypesBase.string),
  descShort: propertyMeta(
    "descShort",
    false,
    false,
    false,
    MetaTypesBase.string,
  ),
  colorCode: propertyMeta(
    "colorCode",
    false,
    false,
    false,
    MetaTypesBase.string,
  ),
  priceDefault: propertyMeta(
    "priceDefault",
    false,
    false,
    false,
    MetaTypesBase.number,
  ),
  disallowIfOverkill: propertyMeta(
    "disallowIfOverkill",
    false,
    false,
    false,
    MetaTypesBase.boolean,
  ),
  teachUrl: propertyMeta("teachUrl", false, false, false, MetaTypesBase.string),
});

const metaI = ApClassTypeBaseMeta;

registerMeta(() => {
  metaI.interfaces = metaI.interfaces.concat([UnifiedClassTypeBaseMeta]);
  metaI.typeName.inheritedFrom = UnifiedClassTypeBaseMeta.typeName;
  metaI.displayOrder.inheritedFrom = UnifiedClassTypeBaseMeta.displayOrder;
  metaI.prereqMustComplete.inheritedFrom =
    UnifiedClassTypeBaseMeta.prereqMustComplete;
  metaI.interfaces = metaI.interfaces.concat([WithSignupMaxMeta]);
  metaI.signupMax.inheritedFrom = WithSignupMaxMeta.signupMax;
  metaI.interfaces = metaI.interfaces.concat([WithSignupMinMeta]);
  metaI.signupMin.inheritedFrom = WithSignupMinMeta.signupMin;
  metaI.interfaces = metaI.interfaces.concat([WithNoSignupMeta]);
  metaI.noSignup.inheritedFrom = WithNoSignupMeta.noSignup;
});

export class ApClassTypeBaseTracked
  extends UnifiedClassTypeBaseTracked
  implements ApClassTypeBaseTrackedI
{
  changeTracker: boolean = false;
  //isNew: boolean = false
  typeName__I?: string = undefined;
  typeNameIsSet: boolean = false;
  set typeName(v: undefined | string) {
    if (v !== undefined) {
      this.typeName__I = v;
      this.typeNameIsSet = true;
    } else {
      this.typeName__I = v || undefined;
      this.typeNameIsSet = false;
    }
    this.changeTracker = true;
  }
  get typeName() {
    return this.typeName__I;
  }
  displayOrder__I?: number = undefined;
  displayOrderIsSet: boolean = false;
  set displayOrder(v: undefined | number) {
    if (v !== undefined) {
      this.displayOrder__I = v;
      this.displayOrderIsSet = true;
    } else {
      this.displayOrder__I = v || undefined;
      this.displayOrderIsSet = false;
    }
    this.changeTracker = true;
  }
  get displayOrder() {
    return this.displayOrder__I;
  }
  prereqMustComplete__I?: boolean = undefined;
  prereqMustCompleteIsSet: boolean = false;
  set prereqMustComplete(v: undefined | boolean) {
    if (v !== undefined) {
      this.prereqMustComplete__I = v;
      this.prereqMustCompleteIsSet = true;
    } else {
      this.prereqMustComplete__I = v || undefined;
      this.prereqMustCompleteIsSet = false;
    }
    this.changeTracker = true;
  }
  get prereqMustComplete() {
    return this.prereqMustComplete__I;
  }
  signupMax__I?: number = undefined;
  signupMaxIsSet: boolean = false;
  set signupMax(v: undefined | number) {
    if (v !== undefined) {
      this.signupMax__I = v;
      this.signupMaxIsSet = true;
    } else {
      this.signupMax__I = v || undefined;
      this.signupMaxIsSet = false;
    }
    this.changeTracker = true;
  }
  get signupMax() {
    return this.signupMax__I;
  }
  signupMin__I?: number = undefined;
  signupMinIsSet: boolean = false;
  set signupMin(v: undefined | number) {
    if (v !== undefined) {
      this.signupMin__I = v;
      this.signupMinIsSet = true;
    } else {
      this.signupMin__I = v || undefined;
      this.signupMinIsSet = false;
    }
    this.changeTracker = true;
  }
  get signupMin() {
    return this.signupMin__I;
  }
  noSignup__I?: boolean = undefined;
  noSignupIsSet: boolean = false;
  set noSignup(v: undefined | boolean) {
    if (v !== undefined) {
      this.noSignup__I = v;
      this.noSignupIsSet = true;
    } else {
      this.noSignup__I = v || undefined;
      this.noSignupIsSet = false;
    }
    this.changeTracker = true;
  }
  get noSignup() {
    return this.noSignup__I;
  }
  descLong__I?: string = undefined;
  descLongIsSet: boolean = false;
  set descLong(v: undefined | string) {
    if (v !== undefined) {
      this.descLong__I = v;
      this.descLongIsSet = true;
    } else {
      this.descLong__I = v || undefined;
      this.descLongIsSet = false;
    }
    this.changeTracker = true;
  }
  get descLong() {
    return this.descLong__I;
  }
  descShort__I?: string = undefined;
  descShortIsSet: boolean = false;
  set descShort(v: undefined | string) {
    if (v !== undefined) {
      this.descShort__I = v;
      this.descShortIsSet = true;
    } else {
      this.descShort__I = v || undefined;
      this.descShortIsSet = false;
    }
    this.changeTracker = true;
  }
  get descShort() {
    return this.descShort__I;
  }
  colorCode__I?: string = undefined;
  colorCodeIsSet: boolean = false;
  set colorCode(v: undefined | string) {
    if (v !== undefined) {
      this.colorCode__I = v;
      this.colorCodeIsSet = true;
    } else {
      this.colorCode__I = v || undefined;
      this.colorCodeIsSet = false;
    }
    this.changeTracker = true;
  }
  get colorCode() {
    return this.colorCode__I;
  }
  priceDefault__I?: number = undefined;
  priceDefaultIsSet: boolean = false;
  set priceDefault(v: undefined | number) {
    if (v !== undefined) {
      this.priceDefault__I = v;
      this.priceDefaultIsSet = true;
    } else {
      this.priceDefault__I = v || undefined;
      this.priceDefaultIsSet = false;
    }
    this.changeTracker = true;
  }
  get priceDefault() {
    return this.priceDefault__I;
  }
  disallowIfOverkill__I?: boolean = undefined;
  disallowIfOverkillIsSet: boolean = false;
  set disallowIfOverkill(v: undefined | boolean) {
    if (v !== undefined) {
      this.disallowIfOverkill__I = v;
      this.disallowIfOverkillIsSet = true;
    } else {
      this.disallowIfOverkill__I = v || undefined;
      this.disallowIfOverkillIsSet = false;
    }
    this.changeTracker = true;
  }
  get disallowIfOverkill() {
    return this.disallowIfOverkill__I;
  }
  teachUrl__I?: string = undefined;
  teachUrlIsSet: boolean = false;
  set teachUrl(v: undefined | string) {
    if (v !== undefined) {
      this.teachUrl__I = v;
      this.teachUrlIsSet = true;
    } else {
      this.teachUrl__I = v || undefined;
      this.teachUrlIsSet = false;
    }
    this.changeTracker = true;
  }
  get teachUrl() {
    return this.teachUrl__I;
  }
  constructor(config?: ApClassTypeBaseOptional, options?: AssignOptions) {
    super(config, options);
    if (config) {
      this.assignFrom(config, options);
    }
  }
  equals(other?: any): boolean {
    return this == other;
  }
  setIds() {}
  assignFrom(
    config: ApClassTypeBaseOptional,
    options?: AssignOptions,
  ): ApClassTypeBaseTrackedI {
    const optionsRequired = getAssignOptions(options);
    if (config.typeName && this.typeNameApplyFilter(optionsRequired.filter)) {
      this.typeName = config.typeName;
      if (optionsRequired.unassign) this.typeNameIsSet = false;
      else this.typeNameIsSet = true;
    }
    if (
      config.displayOrder &&
      this.displayOrderApplyFilter(optionsRequired.filter)
    ) {
      this.displayOrder = config.displayOrder;
      if (optionsRequired.unassign) this.displayOrderIsSet = false;
      else this.displayOrderIsSet = true;
    }
    if (
      config.prereqMustComplete &&
      this.prereqMustCompleteApplyFilter(optionsRequired.filter)
    ) {
      this.prereqMustComplete = config.prereqMustComplete;
      if (optionsRequired.unassign) this.prereqMustCompleteIsSet = false;
      else this.prereqMustCompleteIsSet = true;
    }
    if (config.signupMax && this.signupMaxApplyFilter(optionsRequired.filter)) {
      this.signupMax = config.signupMax;
      if (optionsRequired.unassign) this.signupMaxIsSet = false;
      else this.signupMaxIsSet = true;
    }
    if (config.signupMin && this.signupMinApplyFilter(optionsRequired.filter)) {
      this.signupMin = config.signupMin;
      if (optionsRequired.unassign) this.signupMinIsSet = false;
      else this.signupMinIsSet = true;
    }
    if (config.noSignup && this.noSignupApplyFilter(optionsRequired.filter)) {
      this.noSignup = config.noSignup;
      if (optionsRequired.unassign) this.noSignupIsSet = false;
      else this.noSignupIsSet = true;
    }
    if (config.descLong && this.descLongApplyFilter(optionsRequired.filter)) {
      this.descLong = config.descLong;
      if (optionsRequired.unassign) this.descLongIsSet = false;
      else this.descLongIsSet = true;
    }
    if (config.descShort && this.descShortApplyFilter(optionsRequired.filter)) {
      this.descShort = config.descShort;
      if (optionsRequired.unassign) this.descShortIsSet = false;
      else this.descShortIsSet = true;
    }
    if (config.colorCode && this.colorCodeApplyFilter(optionsRequired.filter)) {
      this.colorCode = config.colorCode;
      if (optionsRequired.unassign) this.colorCodeIsSet = false;
      else this.colorCodeIsSet = true;
    }
    if (
      config.priceDefault &&
      this.priceDefaultApplyFilter(optionsRequired.filter)
    ) {
      this.priceDefault = config.priceDefault;
      if (optionsRequired.unassign) this.priceDefaultIsSet = false;
      else this.priceDefaultIsSet = true;
    }
    if (
      config.disallowIfOverkill &&
      this.disallowIfOverkillApplyFilter(optionsRequired.filter)
    ) {
      this.disallowIfOverkill = config.disallowIfOverkill;
      if (optionsRequired.unassign) this.disallowIfOverkillIsSet = false;
      else this.disallowIfOverkillIsSet = true;
    }
    if (config.teachUrl && this.teachUrlApplyFilter(optionsRequired.filter)) {
      this.teachUrl = config.teachUrl;
      if (optionsRequired.unassign) this.teachUrlIsSet = false;
      else this.teachUrlIsSet = true;
    }
    if (optionsRequired.unassignChangeTracker) this.changeTracker = false;
    if (options?.isNew !== null && options?.isNew !== undefined)
      updateIsNew(this, optionsRequired.isNew);
    return this;
  }
  shouldRemove(skipPK: boolean = true): boolean {
    if (isNew(this) && isDeleted(this)) return true;
    return (
      !this.changeTracker && !this.anySet((a, b) => !skipPK || !a.isPrimary)
    );
  }
  removeUnset(filter?: FilterVarsType): ApClassTypeBaseTrackedI {
    const cloned = {} as ApClassTypeBaseTrackedI;
    if (
      this.typeNameIsSetDeep() &&
      this.typeNameApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.typeNameIsSet = true;
      cloned.typeName = this.typeName;
    } else {
      //cloned.typeNameIsSet = false
    }
    if (
      this.displayOrderIsSetDeep() &&
      this.displayOrderApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.displayOrderIsSet = true;
      cloned.displayOrder = this.displayOrder;
    } else {
      //cloned.displayOrderIsSet = false
    }
    if (
      this.prereqMustCompleteIsSetDeep() &&
      this.prereqMustCompleteApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.prereqMustCompleteIsSet = true;
      cloned.prereqMustComplete = this.prereqMustComplete;
    } else {
      //cloned.prereqMustCompleteIsSet = false
    }
    if (
      this.signupMaxIsSetDeep() &&
      this.signupMaxApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.signupMaxIsSet = true;
      cloned.signupMax = this.signupMax;
    } else {
      //cloned.signupMaxIsSet = false
    }
    if (
      this.signupMinIsSetDeep() &&
      this.signupMinApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.signupMinIsSet = true;
      cloned.signupMin = this.signupMin;
    } else {
      //cloned.signupMinIsSet = false
    }
    if (
      this.noSignupIsSetDeep() &&
      this.noSignupApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.noSignupIsSet = true;
      cloned.noSignup = this.noSignup;
    } else {
      //cloned.noSignupIsSet = false
    }
    if (
      this.descLongIsSetDeep() &&
      this.descLongApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.descLongIsSet = true;
      cloned.descLong = this.descLong;
    } else {
      //cloned.descLongIsSet = false
    }
    if (
      this.descShortIsSetDeep() &&
      this.descShortApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.descShortIsSet = true;
      cloned.descShort = this.descShort;
    } else {
      //cloned.descShortIsSet = false
    }
    if (
      this.colorCodeIsSetDeep() &&
      this.colorCodeApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.colorCodeIsSet = true;
      cloned.colorCode = this.colorCode;
    } else {
      //cloned.colorCodeIsSet = false
    }
    if (
      this.priceDefaultIsSetDeep() &&
      this.priceDefaultApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.priceDefaultIsSet = true;
      cloned.priceDefault = this.priceDefault;
    } else {
      //cloned.priceDefaultIsSet = false
    }
    if (
      this.disallowIfOverkillIsSetDeep() &&
      this.disallowIfOverkillApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.disallowIfOverkillIsSet = true;
      cloned.disallowIfOverkill = this.disallowIfOverkill;
    } else {
      //cloned.disallowIfOverkillIsSet = false
    }
    if (
      this.teachUrlIsSetDeep() &&
      this.teachUrlApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.teachUrlIsSet = true;
      cloned.teachUrl = this.teachUrl;
    } else {
      //cloned.teachUrlIsSet = false
    }
    return cloned;
  }
  unassignAll(filter?: FilterVarsType): ApClassTypeBaseTrackedI {
    if (!this.typeNameApplyFilter(filter)) this.typeNameIsSet = false;

    if (!this.displayOrderApplyFilter(filter)) this.displayOrderIsSet = false;

    if (!this.prereqMustCompleteApplyFilter(filter))
      this.prereqMustCompleteIsSet = false;

    if (!this.signupMaxApplyFilter(filter)) this.signupMaxIsSet = false;

    if (!this.signupMinApplyFilter(filter)) this.signupMinIsSet = false;

    if (!this.noSignupApplyFilter(filter)) this.noSignupIsSet = false;

    if (!this.descLongApplyFilter(filter)) this.descLongIsSet = false;

    if (!this.descShortApplyFilter(filter)) this.descShortIsSet = false;

    if (!this.colorCodeApplyFilter(filter)) this.colorCodeIsSet = false;

    if (!this.priceDefaultApplyFilter(filter)) this.priceDefaultIsSet = false;

    if (!this.disallowIfOverkillApplyFilter(filter))
      this.disallowIfOverkillIsSet = false;

    if (!this.teachUrlApplyFilter(filter)) this.teachUrlIsSet = false;

    return this;
  }
  typeNameApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      ApClassTypeBaseMeta.typeName,
      ApClassTypeBaseMeta,
      this.typeName,
      this,
    );
  }
  typeNameIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.typeNameIsSet && this.typeNameApplyFilter(filter)) return true;

    return false;
  }
  displayOrderApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      ApClassTypeBaseMeta.displayOrder,
      ApClassTypeBaseMeta,
      this.displayOrder,
      this,
    );
  }
  displayOrderIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.displayOrderIsSet && this.displayOrderApplyFilter(filter))
      return true;

    return false;
  }
  prereqMustCompleteApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      ApClassTypeBaseMeta.prereqMustComplete,
      ApClassTypeBaseMeta,
      this.prereqMustComplete,
      this,
    );
  }
  prereqMustCompleteIsSetDeep(filter?: FilterVarsType): boolean {
    if (
      this.prereqMustCompleteIsSet &&
      this.prereqMustCompleteApplyFilter(filter)
    )
      return true;

    return false;
  }
  signupMaxApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      ApClassTypeBaseMeta.signupMax,
      ApClassTypeBaseMeta,
      this.signupMax,
      this,
    );
  }
  signupMaxIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.signupMaxIsSet && this.signupMaxApplyFilter(filter)) return true;

    return false;
  }
  signupMinApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      ApClassTypeBaseMeta.signupMin,
      ApClassTypeBaseMeta,
      this.signupMin,
      this,
    );
  }
  signupMinIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.signupMinIsSet && this.signupMinApplyFilter(filter)) return true;

    return false;
  }
  noSignupApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      ApClassTypeBaseMeta.noSignup,
      ApClassTypeBaseMeta,
      this.noSignup,
      this,
    );
  }
  noSignupIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.noSignupIsSet && this.noSignupApplyFilter(filter)) return true;

    return false;
  }
  descLongApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      ApClassTypeBaseMeta.descLong,
      ApClassTypeBaseMeta,
      this.descLong,
      this,
    );
  }
  descLongIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.descLongIsSet && this.descLongApplyFilter(filter)) return true;

    return false;
  }
  descShortApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      ApClassTypeBaseMeta.descShort,
      ApClassTypeBaseMeta,
      this.descShort,
      this,
    );
  }
  descShortIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.descShortIsSet && this.descShortApplyFilter(filter)) return true;

    return false;
  }
  colorCodeApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      ApClassTypeBaseMeta.colorCode,
      ApClassTypeBaseMeta,
      this.colorCode,
      this,
    );
  }
  colorCodeIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.colorCodeIsSet && this.colorCodeApplyFilter(filter)) return true;

    return false;
  }
  priceDefaultApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      ApClassTypeBaseMeta.priceDefault,
      ApClassTypeBaseMeta,
      this.priceDefault,
      this,
    );
  }
  priceDefaultIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.priceDefaultIsSet && this.priceDefaultApplyFilter(filter))
      return true;

    return false;
  }
  disallowIfOverkillApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      ApClassTypeBaseMeta.disallowIfOverkill,
      ApClassTypeBaseMeta,
      this.disallowIfOverkill,
      this,
    );
  }
  disallowIfOverkillIsSetDeep(filter?: FilterVarsType): boolean {
    if (
      this.disallowIfOverkillIsSet &&
      this.disallowIfOverkillApplyFilter(filter)
    )
      return true;

    return false;
  }
  teachUrlApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      ApClassTypeBaseMeta.teachUrl,
      ApClassTypeBaseMeta,
      this.teachUrl,
      this,
    );
  }
  teachUrlIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.teachUrlIsSet && this.teachUrlApplyFilter(filter)) return true;

    return false;
  }
  anySet(filter?: FilterVarsType): boolean {
    if (this.changeTracker) return true;
    if (this.typeNameIsSetDeep(filter)) return true;
    if (this.displayOrderIsSetDeep(filter)) return true;
    if (this.prereqMustCompleteIsSetDeep(filter)) return true;
    if (this.signupMaxIsSetDeep(filter)) return true;
    if (this.signupMinIsSetDeep(filter)) return true;
    if (this.noSignupIsSetDeep(filter)) return true;
    if (this.descLongIsSetDeep(filter)) return true;
    if (this.descShortIsSetDeep(filter)) return true;
    if (this.colorCodeIsSetDeep(filter)) return true;
    if (this.priceDefaultIsSetDeep(filter)) return true;
    if (this.disallowIfOverkillIsSetDeep(filter)) return true;
    if (this.teachUrlIsSetDeep(filter)) return true;
    return false;
  }
}

import { transformDatesMap } from "@/api/mappers/dtoDateMapper";
